import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

const detectionTypeLabelMap = {
  anomaly: 'anomalies',
  drop: 'drops',
  spike: 'spikes',
};

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesEventFreshnessAnomaliesConfig = ({ watch }: Props) => (
  <>
    {watch('timestampColumn') && (
      <FormControls.FormText>
        Timestamp column: <b>{watch('timestampColumn')}</b>
      </FormControls.FormText>
    )}

    {watch('updatedAtTimestampColumn') && (
      <FormControls.FormText>
        Updated at timestamp column: <b>{watch('updatedAtTimestampColumn')}</b>
      </FormControls.FormText>
    )}

    <FormControls.FormText>
      Detect event freshness{' '}
      <b>{detectionTypeLabelMap[watch('detectionEventType')]}</b> by looking at
      a{' '}
      <b>
        {watch('detectionPeriod')} {watch('detectionUnit')}
      </b>{' '}
      period and comparing it to the last{' '}
      <b>{watch('detectionDaysBack')} days</b>
    </FormControls.FormText>

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default TablesEventFreshnessAnomaliesConfig;
